import * as React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import useGlobalSettings from "src/core/shared/hooks/useGlobalSettings";

/**
 * Stripe Elements provider
 */
const StripeElementsProvider: React.ReactFCWithChildren = ({ children }) => {
  const [ { globalSettings } ] = useGlobalSettings();

  const stripePromise = React.useMemo(async () => {
    if (globalSettings?.payment) {
      return await loadStripe(globalSettings.payment.publicKey, { stripeAccount: globalSettings.payment.accountId });
    }

    return null;
  }, [ globalSettings?.payment ]);

  return (
    <Elements stripe={stripePromise}>
      {children}
    </Elements>
  );
};

export default StripeElementsProvider;
